import React from "react";
import About from "../Components/About";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import Particle from "../Components/Particle";
import Service from "../Components/Service";
import SubmitArea from "../Components/SubmitArea";
import Works from "../Components/Works";

const Home = () => {
  return (
    <div>
      <Particle />
      <Header />
     <Service />
      <Works />
      <About />
      <SubmitArea />
      <Footer />
    </div>
  );
};

export default Home;
